/**
 * Centralized z-index values for consistent layering across the app.
 *
 * MUI default z-index values for reference:
 * - mobileStepper: 1000
 * - fab: 1050
 * - speedDial: 1050
 * - appBar: 1100
 * - drawer: 1200
 * - modal: 1300
 * - snackbar: 1400
 * - tooltip: 1500
 */

export const Z_INDEX = {
  // Local layers (relative to parent)
  popover: 10, // For hover menus, local dropdowns

  // Base layers
  dropdown: 1000,
  appBar: 1100,
  drawer: 1200,

  // Modal layers - must be above drawer
  modal: 1300,
  upgradeModal: 1400, // Higher priority modal for feature gating

  // Top layers
  snackbar: 1500,
  tooltip: 1600,
} as const;
